<ng-content></ng-content>
<ng-template
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayHasBackdrop]="_hasBackdrop"
  (backdropClick)="hide()"
  (detach)="hide()"
  (positionChange)="onPositionChange($event)"
  [cdkConnectedOverlayPositions]="_positions"
  [cdkConnectedOverlayOpen]="visible$ | async">
  <div class="ant-popover" [ngClass]="_classMap" [ngStyle]="dwOverlayStyle" [@fadeAnimation]="''+(visible$ | async)"
    (@fadeAnimation.done)="_afterVisibilityAnimation($event)">
    <div class="ant-popover-content">
      <div class="ant-popover-arrow"></div>
      <div class="ant-popover-inner">
        <div>
          <div class="ant-popover-inner-content">
            <div class="ant-popover-message">
              <ng-container *ngIf="isTitleString; else titleTemplate">
                <i class="anticon anticon-exclamation-circle"></i>
                <div class="ant-popover-message-title">{{ dwTitle }}</div>
              </ng-container>
              <ng-template #titleTemplate>
                <ng-template [ngTemplateOutlet]="dwTitle"></ng-template>
              </ng-template>
            </div>
            <div class="ant-popover-buttons">
              <button dw-button [dwSize]="'small'" (click)="onCancel()">
                <ng-container *ngIf="dwCancelText">{{ dwCancelText }}</ng-container>
                <ng-container *ngIf="!dwCancelText">{{ 'Modal.cancelText' | dwI18n }}</ng-container>
              </button>
              <button dw-button [dwSize]="'small'" [dwType]="dwOkType" (click)="onConfirm()">
                <ng-container *ngIf="dwOkText">{{ dwOkText }}</ng-container>
                <ng-container *ngIf="!dwOkText">{{ 'Modal.okText' | dwI18n }}</ng-container>
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>